import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    description:
      'Your choice has been saved, and we will inform {firstName} {lastName}!',
    title: 'Card request refused',
  },
  fr: {
    description:
      'Votre choix a été enregistré et nous allons informer {firstName} {lastName} !',
    title: 'Demande de carte refusée',
  },
} as const);
